import React from "react";
import {Redirect, Link, useLocation, useHistory} from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import logo from 'assets/img/logo/logo_login.svg';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputPW from 'components/input/inputPW';
import userStore from "common/user/store/UserStore";
import UIUtil from "../../../../utils/UIUtils";
import StringUtil from "utils/StringUtil";
import menuStore from "common/menu/store/MenuStore";
import ValidationUtil from "common/validation/util/ValidationUtil";
import userRepository from "common/user/repository/UserRepository";
import message from "../../../../common/message/source/MessageSource";
import CryptoUtil from "../../../../utils/CryptoUtil";

function ContentsContainer() {
    const [username, setUsername] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [errorCode, setErrorCode] = React.useState<string>("");
    const loginForm = React.useRef<HTMLFormElement>(null);
    const location =  useLocation();
    const [redirectUrl, setRedirectUrl] = React.useState<string>();
    const [onCapsLock, setOnCapsLock] = React.useState(false);
    const [isSave, setIsSave] = React.useState(false);

    const history = useHistory();

    const formId = "loginForm";

    React.useEffect(() => {
        userRepository.logout().then();
        userStore.clearUserStoreNoReplace();
        menuStore.removeCurrentMenu();

        const saveStr = localStorage.getItem("saveUsername");
        if(saveStr) {
            try {
                const saveUsername = JSON.parse(CryptoUtil.decrypt(saveStr));
                setIsSave(saveUsername.isSave);
                setUsername(saveUsername.username);
            }
            catch {}
        }

    }, []);

    let isSubmit = false;
    const handleSubmit = async (event: React.SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        if(ValidationUtil.checkAll()) return;

        if (!isSubmit) {
            isSubmit = true;
            const result = await userStore.login(loginForm.current as HTMLFormElement);
            isSubmit = false;

            if (!result.result) {
                setErrorCode(result.code || "");

                if(result.code == "" && result.message == "") {
                    await UIUtil.alert(<>보안프로그램 설치 완료 확인 후<br/>새로고침 진행해 주세요<br/>[확인]을 선택하시면 설치페이지로 연결됩니다.</>)
                    history.push('./usr_1810');
                }
                else if(result.code !== 'LOGIN9003'
                    && result.code !== 'LOGIN9004'
                    && result.code !== 'LOGIN9005'
                    && result.code !== 'LOGIN9006'
                    && result.code !== 'LOGIN9007'
                ) {
                    await UIUtil.error(result.message||"", result.code||"");
                }
            } else {
                await menuStore.reloadAllList();
                let nextPage = `/main`;
                const searchParams = new URLSearchParams(location.search);
                if (searchParams.get("url")) {
                    nextPage = searchParams.get("url") || nextPage;
                }

                if(isSave) {
                    localStorage.setItem("saveUsername", CryptoUtil.encrypt(JSON.stringify({isSave, username})));
                }
                else {
                    localStorage.removeItem("saveUsername");
                }

                setRedirectUrl(nextPage)
            }
        }
    };

    React.useEffect(() => {
        if (StringUtil.isNotEmpty(redirectUrl)) {
            history.replace({
                pathname: redirectUrl,
                state:  location.state
            })
        }
    }, [redirectUrl])

    return (
        <PageContainer session={false}>
            <div className='fww-con'>
                {/*
                <ul className="fww-brd">
                    <li><Link to="/main/">홈</Link></li>
                    <li><Link to="#">로그인</Link></li>
                </ul>
                 */}
                <main className="fww-main sign-in-main">
                    <div className="sign-in">
                        <div className="left-box">
                            <div className="middle">
                                <ul className="list-group">
                                    <li>출연기업 담당자별로 개별 회원가입이 가능합니다.</li>
                                    <li>출연기업(사업자등록번호)가 일치하면 담당자가 다르더라도<br />출연현황, 과제신청현황, 지급현황 등 조회가 가능합니다.</li>
                                </ul>
                                <div className="sign-in-info">
                                    시스템 사용 문의 고객센터: <span className="fc-333">02-368-8700</span><br />
                                    상생협력기금 출연,사용 신청 등 문의사항 : 사업별 담당자 <Link to="/main/usr_1900/usr_1902"><span  className="fc-333 underline">조직도 바로가기</span></Link>
                                </div>
                            </div>
                        </div>
                        <div className="right-box">
                            <h1 className="tx tx-hd1">로그인</h1>
                            <p className="tx-doc">승인된 상생협력기금 (예비)출연기업 담당자에게<br />서비스를 제공합니다</p>
                            <h4 className="sign-in-title">MEMBERSHIP LOGIN</h4>
                            <form className="sign-form" id={formId} name={formId} ref={loginForm}>
                                <div className="form-items mb12">
                                    <UIInput className={'tf tf-big w100p'}
                                             value={username}
                                             placeholder={message.get("common.user.message.inputLoginUsername")}
                                        //                                      setFocus={focusName === "username"}
                                             attrs={{
                                                 name: "USERNAME",
                                                 alt: message.get("common.user.message.inputLoginUsername"),
                                                 tabIndex: 1,
                                                 autoComplete: "username"
                                             }}
                                             readOnly={false}
                                        //                                              onKeyEnter={() => setFocusName("password")}
                                             valueChanged={(value) => setUsername(value)}
                                             rules={["required"]}
                                    />
                                </div>
                                {/* <p className="tx-invalid mb12">에러 안내 메세지</p> */}
                                <div className="form-items mb12">
                                    <UIInputPW
                                        className={'tf tf-big w100p'}
                                        placeholder={message.get("common.user.message.inputLoginPassword")}
                                        attrs={{
                                            name: "PASSWORD",
                                            alt: message.get("common.user.message.inputLoginPassword"),
                                            tabIndex: 2
                                        }}
                                        readOnly={false}
                                        onKeyEnter={handleSubmit}
                                        valueChanged={(value) => setPassword(value)}
                                        rules={["required"]}
                                        focusClear={true}
                                        isOnCapsLock={result => setOnCapsLock(result)}
                                    />
                                    <UIInput type="hidden"
                                             attrs={{name: "LOGIN_AUTH"}}
                                             value={""}
                                    />
                                </div>
                                <div className="mb30">
                                    <label htmlFor="ch-id" className="hz-item ip-ch-label ip-ch-18">
                                        <input id="ch-id" className="ip-ch" type="checkbox" checked={isSave} onChange={event=> setIsSave(event.target.checked)} />
                                        <span className="check"></span>
                                        <span className="txt">아이디 저장</span>
                                    </label>
                                </div>
                                {username.length == 0 && <p className="tx tx-alert">{message.get("common.user.message.inputLoginUsername")}</p>}
                                {password.length < 8 && <p className="tx tx-alert">{message.get("common.user.message.inputLoginPassword")}</p>}
                    
                                
                                {onCapsLock && <p className="tx tx-alert">Caps Lock이 켜져있습니다.</p>}
                                {errorCode == 'LOGIN9003' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.badCredentials`)}</p>}
                                {errorCode == 'LOGIN9004' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.locked`)}</p>}
                                {errorCode == 'LOGIN9005' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.disabled`)}</p>}
                                {errorCode == 'LOGIN9006' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.expired`)}</p>}
                                {errorCode == 'LOGIN9007' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.notEmailVerify`)}</p>}
                                <div className="hz-root hz-center hz-gap10">
                                    <Button color="pri" size="big" type="submit" onClick={handleSubmit}>{message.get("common.user.message.login", "로그인")}</Button>
                                </div>
                                <div className="sign-link">
                                    <Link className="tx tx-link" to="/main/usr_1000/usr_1200">회원가입</Link>
                                    <Link className="tx tx-link" to="/main/usr_1000/usr_1400">아이디/비밀번호 찾기</Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </main>
            </div>
        </PageContainer>
    );
}
export default ContentsContainer;